<template>
    <section>
        <CouponType v-for = "item in couponlist"
        :coupontype = "item.coupontype"
        :coupontip = "item.coupontip"
        :key = "item.id"
        :id = "item.id"
        :imgsrc="item.imgsrc"
        :selectType = "couponTypeCallback"
        :status = "productId === item.id"
        :activitysrc = "isShowSale && (purchaseFormAlign.payType == 0) && item.activitysrc"
        />
    </section>
</template>

<script>
import CouponType from './CouponType.vue'
import ImgCouponZhuanChe from 'Images/img_coupon_zhuanche.png'
import ImgCouponDaijia from 'Images/img_coupon_daijia.png'
import ImgCouponTongyong from 'Images/img_coupon_tongyong.png'
import ImgCouponKuaiche from 'Images/img_coupon_kuaiche.png'
import ImgCouponHaohuache from 'Images/img_coupon_haohuache.png'
import ImgActivity from 'Images/img_biaoqian.png'

import {mapActions, mapMutations, mapState} from 'vuex'
const InitCouponlist=[{
          id: 210,
          coupontype: '快车',
          coupontip: '快速响应 价格实惠',
          imgsrc: ImgCouponKuaiche,
          status: false,
          activitysrc: ImgActivity
        },
        {
          id: 200,
          coupontype: '专车',
          coupontip: '高端出行 优质服务',
          imgsrc: ImgCouponZhuanChe,
          status: false,
          activitysrc: ImgActivity
        },
        {
          id: 181,
          coupontype: '豪华车',
          coupontip: '接待贵宾的上佳之选',
          imgsrc: ImgCouponHaohuache,
          status: false
        },
        {
          id: 20,
          coupontype: '通用',
          coupontip: '支持用车全品类',
          imgsrc: ImgCouponTongyong,
          status: false,
          activitysrc: ImgActivity
        },
        {
          id: 120,
          coupontype: '代驾',
          coupontip: '便捷 专业的司机服务',
          imgsrc: ImgCouponDaijia,
          status: false
        }]
const InitCouponlistShort=[{
          id: 210,
          coupontype: '快车',
          coupontip: '快速响应 价格实惠',
          imgsrc: ImgCouponKuaiche,
          status: false,
          activitysrc: ImgActivity
        },
        {
          id: 200,
          coupontype: '专车',
          coupontip: '高端出行 优质服务',
          imgsrc: ImgCouponZhuanChe,
          status: false,
          activitysrc: ImgActivity
        },
        {
          id: 181,
          coupontype: '豪华车',
          coupontip: '接待贵宾的上佳之选',
          imgsrc: ImgCouponHaohuache,
          status: false
        }]
export default {
  name: 'CouponTypeList',
  componentName: 'CouponTypeList',
  components: {
    CouponType
  },
  computed: {
    ...mapState('purchase', {
      purchaseFormAlign: 'orderInfo'
    }),
    couponlist:function(){
      console.log('this.purchaseFormAlign.templateDataFrom',this.purchaseFormAlign.templateDataFrom)
      if(this.purchaseFormAlign.templateDataFrom == 't1' || this.purchaseFormAlign.templateDataFrom == 't2'){
        return InitCouponlistShort
      }else{
        return InitCouponlist
      }
    }
  },
  methods: {
    ...mapActions('purchase', [
      'getPriceList'
    ]),
    ...mapMutations('purchase', [
      'SET_PRODUCTID'
    ]),
    couponTypeCallback (id) {
      let target
      console.log(111111, this.purchaseFormAlign.payType)
      for (let i in this.couponlist) {
        if (this.couponlist[i].id !== id) {
          this.couponlist[i].status = false
        } else {
          this.couponlist[i].status = true
          target = i
        }
      }
      this.SET_PRODUCTID({id: id, coupontype: this.couponlist[target].coupontype})
    }
  },
  props: ['productId', 'isShowSale'],
  data: function () {
    return {
    }
  },
  mounted: function () {
    // this.getPriceList({productId: '200,181,120,210'})
    let {sourcetype} = this.$route.query
    // 新建时初始化默认值
    if (sourcetype !== 'edit' && sourcetype !== 'copy') {
      let target = 0
      let {id, coupontype} = this.couponlist[target]
      this.SET_PRODUCTID({id: id, coupontype: coupontype})
    }
  }
}
</script>

<style lang="stylus">
</style>
